import { getExperimentTypeOfUser } from '../../../Utils/helper';

export const updatedExperimentUserType = (userType) =>
  userType ? userType : 'A';

export const getFilterOnBasisOfUserType = (offerData) => {
  const userType = getExperimentTypeOfUser();
  if (userType === 'A' && offerData) {
    return offerData?.filter((offer) => offer.term_id !== 7140);
  }
  return offerData;
};
